import { render, staticRenderFns } from "./DeleteAutomation.vue?vue&type=template&id=52dde4c1"
import script from "./DeleteAutomation.vue?vue&type=script&lang=js"
export * from "./DeleteAutomation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports